import React from "react";
// import { graphql } from "gatsby";
import Slider from "react-slick";
import parse from "html-react-parser";
import { GatsbyImage } from "gatsby-plugin-image";

import sliderLeft from "../images/slider-left.png";
import sliderRight from "../images/slider-right.png";

import "./study_carousel.scss";

const StudyCarousel = ({ posts }) => {
  const blogPosts = posts.allWpPost.nodes
  const settings = {
    rows: 1,
    lazyLoad: true,
    accessibility: true,
    infinite: true,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <button type="button" className="slick-prev"><img src={sliderLeft} alt="..." /></button>,
    nextArrow: <button type="button" className="slick-next"><img src={sliderRight} alt="..." /></button>,
    customPaging: i => <div></div>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
    ],
  };

  return (
    <div className="study-carousel bg-white">
      <div className="row justify-content-md-center">
        <div className="col-sm-12">
          <div className="slider-container">
            <Slider {...settings}>
            
              {blogPosts.map(post => {
                const title = post.title;
                const featuredImage =
                  post.featuredImage?.node?.localFile?.childImageSharp
                    ?.gatsbyImageData;
                const altText = post.featuredImage?.node?.altText || "";
                return (
                  <article className="card" style={{ width: "305px" }} key={post.slug}>
                    <a href={`/blog/` + post.slug}>
                      <GatsbyImage
                        layout="fullWidth"
                        image={featuredImage}
                        alt={altText}
                        className="card-img-bottom featured-image"
                        aspectratio={4/3}

                      />
                    </a>
                    <div className="card-body d-flex flex-column px-0">
                    <a href={`/blog/` + post.slug}><h5 className="card-title">{title}</h5></a>
                      <p className="card-text">{parse(post.excerpt)}</p>
                    </div>
                  </article>
                );
              })}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudyCarousel;
